export const ShippingCarriers = {
	CA: [{ name: 'Canada Post' }, { name: 'UPS' }, { name: 'FedEx' }],
	CN: [{ name: '顺丰速运' }]
}
